// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__3uzuc","clinicsSelect":"TableHeading_clinicsSelect__l6Elh"};